import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import { VoiceChannelMemberGridItem } from 'src/sections/@dashboard/chat/ChatVoiceChannel/VoiceChannelMembersGrid/VoiceMemberGridItem/VoiceChannelMemberGridItem';

export const GatheringCallSidebar = () => {
  const { activeVoiceChannel, connectionStatus, activeMember } =
    useLivekitRTCState();

  const { conversationKey = '' } = useParams();

  const connected = useMemo(
    () => connectionStatus !== 'disconnected',
    [connectionStatus],
  );

  const isOnChatPath = useMemo(() => {
    return conversationKey === activeVoiceChannel?.channel?._id;
  }, [conversationKey, activeVoiceChannel]);

  const activeMemberToRender = useMemo(() => {
    if (!activeMember || !activeVoiceChannel.members.length) return null;
    return activeVoiceChannel.members.find(
      (member) => member.meetId === activeMember,
    );
  }, [activeMember, activeVoiceChannel.members]);

  if (!connected || !activeMemberToRender || isOnChatPath) return null;

  return (
    <Stack sx={{ width: '100%' }}>
      <VoiceChannelMemberGridItem
        key={activeMemberToRender.user?._id}
        member={activeMemberToRender}
        connected={connected}
        isFromNav
      />
    </Stack>
  );
};
